import React from 'react';
import {useSelector} from 'react-redux';

import Utility from '../../../../../../util/utilityfunctions';

import {IconoirWarningCircle} from '@ey-xd/motif-icon';
import OutputText from '@ey/canvascoreservices/OutputText';
import Icon from '@ey/canvascoreservices/Icon';

import Tooltip from '../../../../../CoreWrappers/Tooltip';

const NumberColumnComponent = ({item, getNumber, prop}) => {
	const numberFormat = useSelector(({userPreferences}) => userPreferences.numberFormat);
	return `${Utility.getFormattedNumber(numberFormat, getNumber ? getNumber(item) : item[prop])}`;
};

export const config = ({
	id,
	fullId = null,
	label,
	prop,
	getNumber = null, // function that takes item as parameter
	width = 'minmax(var(--px-160), 1fr)',
	customHeaderTooltip = null
}) => {
	const configObj = {
		id: fullId ? fullId : `${id}NumberColumn`,
		label,
		propName: prop,
		sortBy: prop,
		width,
		align: 'right',
		headerAlign: 'right',
		customCell: (item) => <NumberColumnComponent item={item} getNumber={getNumber} prop={prop} />
	};

	if (customHeaderTooltip)
		configObj.customHeaderCell = (item) => {
			const renderTrigger = () => <Icon src={IconoirWarningCircle} />;

			const props = {
				trigger: renderTrigger(),
				tooltipText: customHeaderTooltip,
				placement: 'top'
			};

			return (
				<>
					<OutputText body2 title={label} ellipsis>
						{label}
					</OutputText>
					<Tooltip {...props} />
				</>
			);
		};

	return configObj;
};
